exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-aligned{\r\n    position: relative;\r\n    top: 25px;\r\n}\r\n\r\n#tableResultados th, td{\r\n    width: 300px;\r\n    padding-right: 15px;\r\n}\r\n\r\n.resultado-consulta{\r\n    overflow-x: auto\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/ewerton.w.da.silva/Documents/Visual Studio 2017/Projects/SCL_Valia/SCL_Valia/src/app/paginas/consultar-dados/consultar-dados.component.css
// module id = ../../../../../src/app/paginas/consultar-dados/consultar-dados.component.css
// module chunks = 1